import { DecimalPipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatter',
    standalone: true
})
export class FormatterPipe implements PipeTransform {
  private readonly decimalPipe = inject(DecimalPipe);

  transform(value: any, args: string): any {
    switch (args) {
      case 'number':
      case 'number_integer':
        return this.decimalPipe.transform(Number.parseInt(value));
      case 'checkbox':
        return `${value}`.toLowerCase() === 'true' ? 'Si' : 'No';
      default:
        return value;
    }
  }
}
